import { React, useState, useEffect } from "react";
import { PortalComponent, ModalComponent, SwitchComponent, CardComponent, TableComponent, ButtonIconComponent, SelectComponent, ButtonActionComponent } from '../../../components/pages/index'
import { useGetApiWs } from "../../../hooks";
import { api, apiConfig } from "../../../util/api";
import Swal from 'sweetalert2';

const AssignChannels = props => {

    const urlCustomer = useGetApiWs('admin', 'entity', 'customer-get');
    const urlCustomerStatus = useGetApiWs('admin', 'entity', 'customer-change-status');
    const urlChannels = useGetApiWs('admin', 'entity', 'channels-get');
    const urlCustomerSave = useGetApiWs('admin', 'entity', 'customer-save');
    const urlCustomerDelete = useGetApiWs('admin', 'entity', 'customer-delete');

    const [studies, setStudies] = useState([]);
    const [lbStudy, setLbStudy] = useState(null);
    const [categories, setCategories] = useState([]);
    const [lbCategories, setLbCategorie] = useState([]);
    const [channels, setChannels] = useState([]);
    const [lbChannels, setLbChannels] = useState([]);

    const [StudyIsLoading, setStudyIsLoading] = useState(true);
    const [CategoryIsLoading, setCategoryIsLoading] = useState(true);
    const [ChannelsIsLoading, setChannelsIsLoading] = useState(true);

    const [TbData, setTbData] = useState([]);

    const fetchCustomersStudies = async () => {
        const req = await api().post(urlCustomer, { type_info: 'studies', customer_id: props.companyId }, apiConfig());
        var options = req.data.response.map((obj) => {
            var rObj = {};
            rObj['value'] = obj.study_type_id;
            rObj['label'] = obj.study_type_name;
            return rObj;
        });
        setStudies(options);
        setStudyIsLoading(false);
    }

    const fecthCustomerCategories = async (studiesId) => {
        const req = await api().post(urlCustomer, { type_info: `categories`, study_id: studiesId, customer_id: props.companyId }, apiConfig());
        var options = req.data.response.map((obj) => {
            var rObj = {};
            rObj['value'] = obj.category_id;
            rObj['label'] = obj.category_name;
            return rObj;
        });
        setCategories(options);
        setCategoryIsLoading(false);
    }

    const fecthCustomerCategoriesChannels = async (studiesId, categoriesId) => {
        const req = await api().post(urlCustomer, { type_info: `channels`, category_id: categoriesId, customer_id: props.companyId, study_id: studiesId }, apiConfig());
        if (req.data.status === 'success') {
            setTbData(req.data.response);
        } else {
            console.log(req);
        }
        setCategoryIsLoading(false);
    }

    const fetchChannelsLeft = async (studiesId) => {
        const req = await api().post(urlChannels, { customer_id: props.companyId, study_id: studiesId }, apiConfig());
        const res = req.data;
        if (res.status === 'success') {
            var options = res.response.map(obj => {
                var rObj = {};
                rObj['value'] = obj.channel_id
                rObj['label'] = obj.name
                return rObj;
            });
            setChannels(options)
        } else {
            console.log(res);
        }
        setCategoryIsLoading(false);
    }

    const fetchSave = async () => {
            const params = {};
            params['type_info'] = 'channels'
            params['study_id'] = lbStudy.value
            params['category_id'] = lbCategories.value
            params['channel_id'] = lbChannels.value
            params['customer_id'] = props.companyId
            await api().post(urlCustomerSave, params, apiConfig());
            fetchChannelsLeft(lbStudy.value)
            fecthCustomerCategoriesChannels(lbStudy.value, lbCategories.value);
            setChannels([]);
            setLbChannels([]);
        
    }

    const fetchDelete = async (id) => {
        await api().post(urlCustomerDelete, { type_info: `channels`, customer_category_channel_id: id }, apiConfig());
        setChannels([]);
        setLbChannels(null);
        fetchChannelsLeft(lbStudy.value)
        fecthCustomerCategoriesChannels(lbStudy.value, lbCategories.value)
        Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Se eliminó correctamente',
            showConfirmButton: false,
            timer: 1000
        })
    }
    const StudyChange = async vals => {
        setLbStudy(vals)
        if (vals === null) {
            setLbCategorie(null)
            setCategories([])
            setLbChannels(null)
            setChannels([])
        } else {
            setLbCategorie(null)
            setCategories([])
            setLbChannels(null)
            setChannels([])
            fecthCustomerCategories(vals.value)
        }
    }

    const CategoryChange = async vals => {
        setLbCategorie(vals)
        if (vals === null) {
            setChannels([])
            setLbChannels(null)
        } else {
            setLbChannels(null)
            setChannels([])
            fetchChannelsLeft(lbStudy.value, vals.value)
            fecthCustomerCategoriesChannels(lbStudy.value, vals.value)
        }
    }

    const ChannelsChange = async vals => {
        setLbChannels(vals);
    }

    const tbColumns = [
        /* { name: 'ID', selector: row => row.customer_category_channel_id, hide: 'lg' }, */
        { name: 'CANALES', selector: row => row.name, wrap: true },
        { name: 'ELIMINAR', button: true, cell: row => <BtnDelete customer_category_channel_id={row.customer_category_channel_id} ></BtnDelete> }
    ]

    const BtnDelete = (props) => {
        return (
            <div>
                <ButtonIconComponent icon="trash" onClick={() => { fetchDelete(props.customer_category_channel_id) }} className="bg-red-500 p-2 m-1 rounded-md text-white"></ButtonIconComponent>
            </div>
        )
    }

    useEffect(() => {
        fetchCustomersStudies();
    }, [])

    return (
        <PortalComponent>
            <ModalComponent header={"ASIGNAR CANALES"} onCloseModal={props.closeModal}>
                <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-4">
                    <div className="grid grid-cols-1 gap-4 content-start">
                        <SelectComponent label="ESTUDIOS" options={studies} value={lbStudy} onChange={StudyChange} isLoading={StudyIsLoading} />
                        <SelectComponent label="CATEGORIAS" options={categories} value={lbCategories} onChange={CategoryChange} isLoading={CategoryIsLoading} />
                        <SelectComponent label="CANALES RESTANTES" options={channels} value={lbChannels} onChange={ChannelsChange} isLoading={ChannelsIsLoading} />
                        <ButtonActionComponent name="AGREGAR" onClick={fetchSave} />
                    </div>
                    <div>
                        <CardComponent header={<h3 className="font-medium" >CANALES</h3>} footer={null}>
                            <TableComponent keyField="customer_category_id" columns={tbColumns} data={TbData} highlightOnHover={true} />
                        </CardComponent>
                    </div>
                </div>
            </ModalComponent>
        </PortalComponent>
    )
}

export default AssignChannels;